import { render } from "./Router4.vue?vue&type=template&id=89812376&scoped=true"
import script from "./Router4.vue?vue&type=script&lang=js"
export * from "./Router4.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89812376"]])

export default __exports__